// ============================================================================
// W-06 — a feedback title that is just the category name.
//
// AFB-0075's title is the literal string 'improvement', which is also its
// feedback_type. The record therefore reads as untitled in every list view, and
// would be untitled in the closure notification its reporter receives, because
// notify_src_app_feedback builds that title from this column.
//
// The worklist attributed this to the form defaulting the title to the type. It
// did not: `source` is 'button', FeedbackButton has always rejected a blank
// title and always sent `title.trim()` verbatim, and 1 record in 78 is affected.
// A code path would have produced many more. Somebody retyped the category they
// had just picked, into a field labelled Title with the placeholder "One-line
// summary".
//
// So this is not a leak to plug, it is a mistake to name at the moment it is
// made. Pure and tested rather than inline in the component, so the vocabulary
// it rejects can be checked against the vocabulary the form offers.
// ============================================================================

/**
 * True when `title` is nothing more than one of the feedback category words.
 *
 * Compares on the canonical form — trimmed, lowercased, inner whitespace folded
 * to underscores — so "Feature Request" is caught as well as "feature_request".
 * Anything with real words in it ("Improvement to the fee display") is fine: the
 * check is for a title that carries no information the type doesn't already.
 */
export function isCategoryWordTitle(title: string, categories: readonly string[]): boolean {
  const canonical = title.trim().toLowerCase().replace(/\s+/g, '_');
  if (canonical === '') return false; // blank is a different error, already handled
  return categories.includes(canonical);
}
